import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaBehance, FaYoutube, FaInstagram, FaFacebook } from 'react-icons/fa6';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const ContactInfo = () => {
  const offices = [
    {
      city: 'Ahmedabad, GJ, IN',
      flag: 'https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1200px-Flag_of_India.svg.png',
      address: 'Sakar IX, Ahmedabad, Gujarat, India, 380009',
      phone: '+91 9106982981',
      email: 'info@trioperspective.com'
    },
    {
      city: 'Sheridan, WY, USA',
      flag: 'https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/1200px-Flag_of_the_United_States.svg.png',
      address: '30 N Gould St Ste R Sheridan, WY 82801 USA',
      phone: '+1 (914) 904-6362',
      email: 'info@trioperspective.com'
    }
  ];

  const socialLinks = [
    { Icon: FaLinkedin, url: 'https://www.linkedin.com/company/trioperspective' },
    { Icon: FaBehance, url: 'https://www.behance.net/trioperspective' },
    { Icon: FaYoutube, url: 'https://www.youtube.com/@trioperspective' },
    { Icon: FaInstagram, url: 'https://www.instagram.com/trioperspective/' },
    { Icon: FaFacebook, url: 'https://www.facebook.com/trioperspective' }
  ];

  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Offices Grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-20 items-center">
            {offices.map((office, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white/5 backdrop-blur-sm rounded-2xl p-8"
              >
                <div className="flex items-center gap-4 mb-6">
                  <img 
                    src={office.flag} 
                    alt={`${office.city} flag`} 
                    className="w-8 h-6 object-cover rounded"
                  />
                  <h3 className="text-2xl font-bold text-white">{office.city}</h3>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="text-gray-400 mt-1">
                      <FaMapMarkerAlt size={20} />
                    </div>
                    <div>
                      <p className="text-white whitespace-pre-line">
                        {office.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="text-gray-400">
                      <FaPhone size={20} />
                    </div>
                    <a 
                      href={`tel:${office.phone}`} 
                      className="text-white hover:text-primary transition-colors"
                    >
                      {office.phone}
                    </a>
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="text-gray-400">
                      <FaEnvelope size={20} />
                    </div>
                    <a 
                      href={`mailto:${office.email}`} 
                      className="text-white hover:text-primary transition-colors"
                    >
                      {office.email}
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h3 className="text-2xl font-bold text-white mb-8">Follow Us</h3>
            <div className="grid grid-cols-5 gap-4 max-w-lg mx-auto">
              {socialLinks.map(({ Icon, url }, index) => (
                <a 
                  key={index}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="aspect-square relative text-gray-600 dark:text-gray-400 bg-gray-50/50 dark:bg-black/20 backdrop-blur-sm rounded-lg p-4 hover:text-black dark:hover:text-black hover:bg-primary dark:hover:bg-primary transition-colors flex items-center justify-center overflow-hidden group"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <Icon className="w-10 h-10 relative z-10" />
                </a>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
